const transportationServiceAddressTypes = {
  departure: 2073,
  place: 2074
};

export default transportationServiceAddressTypes;
